import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NzTreeComponent } from "ng-zorro-antd/tree";

@Component({
  selector: 'app-facet-tree-filter',
  templateUrl: './facet-tree-filter.component.html',
  styleUrls: ['./facet-tree-filter.component.scss']
})
export class FacetTreeFilterComponent {
  @Input() loading: boolean;
  @Input() panel;
  @Input() activePanel = "";
  @Input() refreshCurrentPanel = false;
  @Input() facetData = {};
  @Input() cachedSelections = {};
  @Input() facetCategorySearch = {};
  @Output() onPanelExpandChange: EventEmitter<any> = new EventEmitter();
  @Output() onPanelHierarchyOptionChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(NzTreeComponent) nzTreeComponent: NzTreeComponent;
  
  customSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };
  
  // ngOnChanges(changes) {
  //   debugger;
  //   console.log(changes)
  // }

  onExpandChange(param, panel) {
    this.onPanelExpandChange.emit({param, panel});
  }

  onHierarchyOptionChange(category, option) {
    this.onPanelHierarchyOptionChange.emit({category, option});
  }
}
